import { RUN_VISUAL_SCAN_ASYNC } from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case RUN_VISUAL_SCAN_ASYNC.INITIATE:
        return { ...state, loader: true }
      case RUN_VISUAL_SCAN_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data.response,
          loader: false,
        }
      default:
        return state
    }
  }
}
